import React, { useMemo } from 'react'

import { useTheme } from '@mui/material/styles'

import EventListItem from 'components/EventListItem'
import SectionHeader from 'components/SectionHeader'
import { useEvent } from 'hooks/useEvent'

export default function EventList({ limit }) {
  const { palette } = useTheme()
  const { eventResources } = useEvent()

  const filtered = useMemo(() => {
    return typeof limit === 'number' ? eventResources.slice(0, limit) : eventResources
  }, [limit, eventResources])

  return (
    <div style={{ background: palette.background.paper }}>
      <SectionHeader primary="EVENT" />
      {filtered.map(resource => (
        <EventListItem key={resource.event.id} eventResource={resource} />
      ))}
    </div>
  )
}
